import {css} from '@emotion/react';
import 'webapp-lib/assets/css/tokens.css';
import 'webapp-lib/assets/css/properties.css';
import 'webapp-lib/assets/css/global.css';
import {mixinFocus, mixinOverflow} from 'webapp-lib/styling';

export const globalStyles = css`
  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Thin.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Thin.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Thin.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Thin.ttf')
        format('truetype'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Thin.svg#Roboto-Thin')
        format('svg');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-ThinItalic.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-ThinItalic.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-ThinItalic.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-ThinItalic.ttf')
        format('truetype'),
      url('${process.env
          .PUBLIC_URL}/fonts/Roboto/Roboto-ThinItalic.svg#Roboto-ThinItalic')
        format('svg');
    font-weight: 100;
    font-style: italic;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Light.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Light.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Light.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Light.ttf')
        format('truetype'),
      url('${process.env
          .PUBLIC_URL}/fonts/Roboto/Roboto-Light.svg#Roboto-Light')
        format('svg');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-LightItalic.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-LightItalic.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-LightItalic.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-LightItalic.ttf')
        format('truetype'),
      url('${process.env
          .PUBLIC_URL}/fonts/Roboto/Roboto-LightItalic.svg#Roboto-LightItalic')
        format('svg');
    font-weight: 300;
    font-style: italic;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Regular.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Regular.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Regular.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Regular.ttf')
        format('truetype'),
      url('${process.env
          .PUBLIC_URL}/fonts/Roboto/Roboto-Regular.svg#Roboto-Regular')
        format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Italic.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Italic.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Italic.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Italic.ttf')
        format('truetype'),
      url('${process.env
          .PUBLIC_URL}/fonts/Roboto/Roboto-Italic.svg#Roboto-Italic')
        format('svg');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Medium.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Medium.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Medium.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Medium.ttf')
        format('truetype'),
      url('${process.env
          .PUBLIC_URL}/fonts/Roboto/Roboto-Medium.svg#Roboto-Medium')
        format('svg');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-MediumItalic.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-MediumItalic.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-MediumItalic.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-MediumItalic.ttf')
        format('truetype'),
      url('${process.env
          .PUBLIC_URL}/fonts/Roboto/Roboto-MediumItalic.svg#Roboto-MediumItalic')
        format('svg');
    font-weight: 500;
    font-style: italic;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Bold.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Bold.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Bold.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Bold.ttf')
        format('truetype'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Bold.svg#Roboto-Bold')
        format('svg');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-BoldItalic.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-BoldItalic.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-BoldItalic.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-BoldItalic.ttf')
        format('truetype'),
      url('${process.env
          .PUBLIC_URL}/fonts/Roboto/Roboto-BoldItalic.svg#Roboto-BoldItalic')
        format('svg');
    font-weight: bold;
    font-style: italic;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Black.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Black.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Black.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Black.ttf')
        format('truetype'),
      url('${process.env
          .PUBLIC_URL}/fonts/Roboto/Roboto-Black.svg#Roboto-Black')
        format('svg');
    font-weight: 900;
    font-style: normal;
  }

  @font-face {
    font-family: 'Roboto';
    src: url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-BlackItalic.eot');
    src:
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-BlackItalic.woff2')
        format('woff2'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-BlackItalic.woff')
        format('woff'),
      url('${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-BlackItalic.ttf')
        format('truetype'),
      url('${process.env
          .PUBLIC_URL}/fonts/Roboto/Roboto-BlackItalic.svg#Roboto-BlackItalic')
        format('svg');
    font-weight: 900;
    font-style: italic;
  }

  a:focus {
    ${mixinFocus}
  }

  #root {
    height: 100%;
    ${mixinOverflow}
  }

  input {
    font-size: var(--font-size-default);
    font-weight: var(--font-weight-thin);
  }

  ::-webkit-scrollbar {
    visibility: hidden;
    border-radius: 20px;
    width: 5px;
    height: 5px;
    background: var(--scrollbar-color);
  }

  *:hover {
    ::-webkit-scrollbar {
      visibility: visible;
    }
    ::-webkit-scrollbar-thumb {
      visibility: visible;
    }
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background: var(--scrollbar-thumb-color);
    visibility: hidden;
  }

  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }

  .react-pdf__Page__textContent {
    display: none;
  }

  .disabled-form-overlay {
    opacity: 0.5;
    filter: grayscale(100%);
    pointer-events: none;
  }
`;
